import { Hero, Audience, ServicesBento } from "../components/home/SectionsA";
import { Certified, Interpreting, Process, Trust, AboutIntro, LatestPosts, UploadCta, ContactCta } from "../components/home/SectionsB";
import { Marquee } from "../components/Marquee";
import { useSeo } from "../lib/seo";

export default function Home({ doc, alternates }) {
  useSeo({ title: doc.meta_title || doc.title, description: doc.meta_description, path: doc.path, lang: doc.lang, alternates });
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Audience />
      <ServicesBento />
      <Certified />
      <Interpreting />
      <Process />
      <Trust />
      <AboutIntro />
      <LatestPosts />
      <UploadCta />
      <ContactCta />
    </main>
  );
}
